import styled from 'styled-components'

export const Image = styled.img`
  width: 100px;
  border-radius: 5px;
`
